import React, { Component } from "react";
import { post } from "axios";
import {
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  Collapse,
  CardBody,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import Dropzone from "react-dropzone";
import Countdown from "react-countdown";
import { withRouter } from "react-router";
import { NotificationManager } from "react-notifications";
import Toggle from "react-toggle";
import moment from "moment";
import JSMpeg from "jsmpeg-player";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import Slider, { createSliderWithTooltip } from "rc-slider";
import DropzoneComponent from "react-dropzone-component";
import ReactDOMServer from "react-dom/server";
import "react-toggle/style.css";
import "rc-slider/assets/index.css";
import stopReload from "../../constants/Constants";
import audio from "../../audio";
import {
  destroyKasmShareId,
  createKasmShareId,
} from "../../actions/actionDashboard";
import configure from "../../../assets/images/configure.png";
import deleteIcon from "../../../assets/images/delete.png";
import redTrashCanIcon from "../../../assets/images/redTrashCan.png";
import download from "../../../assets/images/download.png";
import clipboard from "../../../assets/images/clipboard.png";
import apps from "../../../assets/images/apps.png";
import leftArrow from "../../../assets/images/leftArrow.png";
import mute from "../../../assets/images/mute.png";
import soundEnabled from "../../../assets/images/soundEnabled.png";
import streaming from "../../../assets/images/streaming.png";
import upload from "../../../assets/images/upload.png";
import logout from "../../../assets/images/logout.png";
import share from "../../../assets/images/share.png";
import cross from "../../../assets/images/cross.png";
import file from "../../../assets/images/file.png";
import unmute from "../../../assets/images/unmute.png";
import soundDisabled from "../../../assets/images/soundDisabled.png";
import info from "../../../assets/images/info.png";

const SliderWithTooltip = createSliderWithTooltip(Slider);

const marks = {
  0: <strong>Static</strong>,
  1: <strong>Low</strong>,
  2: <strong>Medium</strong>,
  3: {
    style: {
      color: "red",
    },
    label: <strong>High</strong>,
  },
};

var player;
var keepAlive;
var renderNav;
var renderNav2;

const sideBarIcons = [
  {
    id: 1,
    icon: leftArrow,
    isActive: false,
  },
  {
    id: 2,
    icon: soundEnabled,
    isActive: false,
  },
  {
    id: 3,
    icon: mute,
    isActive: false,
  },
  {
    id: 4,
    icon: download,
    isActive: false,
  },
  {
    id: 5,
    icon: upload,
    isActive: false,
  },
  {
    id: 6,
    icon: streaming,
    isActive: false,
  },
  {
    id: 7,
    icon: share,
    isActive: false,
  },
  {
    id: 8,
    icon: configure,
    isActive: false,
  },
  {
    id: 9,
    icon: apps,
    isActive: false,
  },
  {
    id: 10,
    icon: logout,
    isActive: false,
  },
  {
    id: 1,
    icon: deleteIcon,
    isActive: false,
  },
];

const IS_TOUCH_DEVICE = (
  ("ontouchstart" in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0)
);

const IS_WINDOWS = navigator && !!(/win/i).exec(navigator.platform);

class ControlPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      showNav: false,
      downloads: [],
      files: [],
      audio: true,
      microphone: false,
      collapse: false,
      currentIndex: null,
      modalclipboard: false,
      modaldownload: false,
      modalvideo: false,
      modaluploads: false,
      modaldestroy: false,
      modalsharing: false,
      shareLink: null,
      message: null,
      disableIndex: [],
      clipboardText: "",
      modalAdvanced: false,
      destroyClicked: false,
      linkError: "",
      clipboardUp: false,
      clipboardDown: false,
      logoutAll: false,
      isShowDownload: false,
      isShowClipboard: false,
      keyboardControlsMode: window.localStorage.getItem("default_keyboard_controls_mode") || "auto"
    };
    if (this.props.statusKasms.port_map.uploads){
      this.componentConfig = {
        postUrl: `https://${this.props.statusKasms.hostname}:${this.props.statusKasms.port_map.uploads.port}/${this.props.statusKasms.port_map.uploads.path}/upload`,
      };
    }
    else{
      this.componentConfig = {
        postUrl: ``,
      };
    }

    this.djsConfig = {
      withCredentials: true,
      autoProcessQueue: true,
      paramName: "file",
      maxFilesize: 200 * 1024 * 1024 * 1024, //Have to set a max file size
      maxFiles: null,
      parallelUploads: 10,
      chunking: true,
      chunkSize: 10000000,
      forceChunking: true,
      timeout: 0,
      dictDefaultMessage: "Drop Files Here or Select Box to Add Files",
      previewTemplate: ReactDOMServer.renderToStaticMarkup(<div></div>),
    };

    this.dropzone = null;

    this.showNav = this.showNav.bind(this);
    this.hideNav = this.hideNav.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.refreshNavState = this.refreshNavState.bind(this);
    this.confirmLogout = this.confirmLogout.bind(this);
    this.cancelLogout = this.cancelLogout.bind(this);
    this.destroyKasmsFun = this.destroyKasmsFun.bind(this);
    this.showLogout = this.showLogout.bind(this);
    this.showDestroy = this.showDestroy.bind(this);
    this.toggleLogout = this.toggleLogout.bind(this);
    this.toggleDownload = this.toggleDownload.bind(this);
    this.toggleClipboard = this.toggleClipboard.bind(this);
    this.toggleSharing = this.toggleSharing.bind(this);
    this.toggleUploads = this.toggleUploads.bind(this);
    this.toggleDestroy = this.toggleDestroy.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleVideo = this.toggleVideo.bind(this);
    this.showMessage = this.showMessage.bind(this);
    this.downloadsList = this.downloadsList.bind(this);
    this.handleClipboard = this.handleClipboard.bind(this);
    this.handleAudioChange = this.handleAudioChange.bind(this);
    this.handleMicrophoneChange = this.handleMicrophoneChange.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleAudioProcess = this.handleAudioProcess.bind(this);
    this.destroyMicrophone = this.destroyMicrophone.bind(this);
    this.connectMicrophone = this.connectMicrophone.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.toggleAdvanced = this.toggleAdvanced.bind(this);
    this.handlePreferLocalCursorChange = this.handlePreferLocalCursorChange.bind(
      this
    );
    this.setPreferLocalCursor = this.setPreferLocalCursor.bind(this);
    this.handleUploadprogress = this.handleUploadprogress.bind(this);
    this.handleAddedFile = this.handleAddedFile.bind(this);
    this.handleSuccessFile = this.handleSuccessFile.bind(this);
    this.bytesToSize = this.bytesToSize.bind(this);
    this.resetDropzone = this.resetDropzone.bind(this);
    this.handleError = this.handleError.bind(this);
    this.clearFiles = this.clearFiles.bind(this);
    this.fileCanceled = this.fileCanceled.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.handleCreateShareLink = this.handleCreateShareLink.bind(this);
    this.handleDestroyShareLink = this.handleDestroyShareLink.bind(this);
    this.hideNavDelay = this.hideNavDelay.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.updateLogoutAll = this.updateLogoutAll.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeAllModals = this.closeAllModals.bind(this);
  }

  handleLeave(location) {
    console.trace("Navigating browser to " + location);
    window.removeEventListener("beforeunload", stopReload, true);
    this.props.history.push(location);
  }

  handleError(file) {
    let copy = this.state.files.slice();
    for (let i = 0; i < copy.length; i++) {
      if (file.name === copy[i].name) {
        copy[i].error = file.xhr.response;
        copy[i].color = "danger";
        this.setState({ files: copy });
      }
    }
  }

  fileCanceled(file, xhr, formData) {
    xhr.ontimeout = function (e) {
      alert("Error canceled upload. Most likely due to network issues.");
    };
  }

  clearFiles() {
    let copy = this.state.files.slice();
    for (let i = 0; i < copy.length; i++) {
      this.dropzone.removeFile(copy[i].file);
    }
    this.setState({ files: [] });
  }

  resetDropzone() {
    this.dropzone.removeAllFiles();
  }

  removeFile(file) {
    this.dropzone.removeFile(file.file);
    let copy = this.state.files.slice();
    for (let i = 0; i < copy.length; i++) {
      if (copy[i].name === file.name) {
        copy.splice(i, 1);
        this.setState({ files: copy });
      }
    }
  }

  handleAddedFile(file) {
    let copy = this.state.files.slice();
    let size = this.bytesToSize(file.size);
    copy.push({
      file: file,
      name: file.name,
      size: size,
      error: "",
      color: "info",
      progress: 0,
    });
    this.setState({ files: copy });
  }

  bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }

  handleCreateShareLink() {
    this.props
      .createKasmShareId(this.props.statusKasms.kasm_id)
      .then(() => {
        const { createShareError, share_id } = this.props;
        if (createShareError) {
          this.setState({
            shareLink: share_id,
            linkError: createShareError,
          });
          this.props.shareEnabled(false);
        } else
          this.setState({
            shareLink: share_id,
            linkError: "",
          });
        if (!this.props.disableFixedRes) {
          this.setState({ videoQuality: 0 });
          this.props.setVideoQuality(0);
        }
        this.props.shareEnabled(true);
      })
      .catch(() => {
        const { createShareError, share_id } = this.props;
        this.setState({
          shareLink: share_id,
          linkError: "Error Creating Link",
        });
        this.props.shareEnabled(false);
      });
  }

  handleDestroyShareLink() {
    this.props
      .destroyKasmShareId(this.props.statusKasms.kasm_id)
      .then(() => {
        const { createShareError, share_id } = this.props;
        if (createShareError) {
          this.setState({
            shareLink: share_id,
            linkError: createShareError,
          });
          this.props.shareEnabled(false);
        } else
          this.setState({
            shareLink: share_id,
            linkError: "",
            videoQuality: 2,
          });
        this.props.setVideoQuality(2);
        this.props.shareEnabled(false);
      })
      .catch(() => {
        const { createShareError, share_id } = this.props;
        console.log(createShareError);
        this.setState({
          shareLink: share_id,
          linkError: "Error Deleting Link",
        });
        this.props.shareEnabled(false);
      });
  }

  handleSuccessFile(file) {
    setTimeout(
      function () {
        let copy = this.state.files.slice();
        for (let i = 0; i < copy.length; i++) {
          if (copy[i].name === file.name) {
            copy.splice(i, 1);
            this.setState({ files: copy });
          }
        }
      }.bind(this),
      2000
    );
  }

  handleUploadprogress(file, progress, bytesSent) {
    let copy = this.state.files.slice();
    for (let i = 0; i < copy.length; i++) {
      if (file.name === copy[i].name) {
        let progressChunk = progress;
        progressChunk = Math.round((bytesSent / file.size) * 100);
        copy[i].progress = progressChunk;
        if (progressChunk === 100) copy[i].color = "success";
        this.setState({ files: copy });
      }
    }
  }

  handleAudioChange(enable) {
    const { statusKasms } = this.props;

    if (!statusKasms.port_map.audio) {
      return;
    }

    if (enable) {
      audio.enable();
    } else {
      audio.disable();
    }

    this.setState({ audio: enable });
  }

  handleMicrophoneChange(value) {
    // let value = e.target.checked;
    value ? this.connectMicrophone() : this.destroyMicrophone();
    this.setState({
      microphone: value,
    });
  }

  handlePreferLocalCursorChange(e) {
    console.log("e.target.checkede.target.checked=", e.target.checked);
    let value = e.target.checked;
    this.setPreferLocalCursor(value);
  }

  setPreferLocalCursor(v) {
    window.localStorage.setItem("prefer_local_cursor", v);
  }

  setKeyboardControlsMode(mode) {
    window.localStorage.setItem("default_keyboard_controls_mode", mode);

    this.setState({
      keyboardControlsMode: mode
    });

    if (mode === "on" || (mode === "auto" && !IS_WINDOWS && IS_TOUCH_DEVICE)) {
      document.querySelector("#iframe-id").contentWindow.postMessage({
        action: "show_keyboard_controls"
      }, "*");
    } else {
      document.querySelector("#iframe-id").contentWindow.postMessage({
        action: "hide_keyboard_controls"
      }, "*");
    }
  }

  showLogout() {
    this.setState({
      modal: true,
      showNav: false,
    });
  }

  showDestroy() {
    this.closeAllModals();
    this.setState({
      modaldestroy: true,
      showNav: false,
    });
  }

  confirmLogout() {
    this.toggleLogout();
    window.removeEventListener("beforeunload", stopReload, true);
    let logout_data = { logout_all: this.state.logoutAll };
    this.props.logout(logout_data);
  }

  destroyKasmsFun() {
    this.props
      .destroyKasms(this.props.statusKasms.kasm_id)
      .then(() => this.handleDeleteSuccess())
      .catch(() => this.handleDeleteError());
    this.setState({ destroyClicked: true });
    this.props.toggleLoader();
    this.toggleDestroy();
  }

  handleDeleteSuccess() {
    const { destroyKasmsErrorMessage } = this.props;
    if (destroyKasmsErrorMessage) {
      NotificationManager.error(destroyKasmsErrorMessage, "Delete Session", 3000);
    } else {
      this.handleLeave("/userdashboard");
    }
  }

  handleDeleteError() {
    const { deleteKasmsError } = this.props;
    if (deleteKasmsError) {
      NotificationManager.error(deleteKasmsError, "Delete Session", 3000);
    } else {
      NotificationManager.error("Failed to Delete Session", "Delete Session", 3000);
    }
  }

  componentDidMount() {
    if (this.props.statusKasms.share_id) {
      this.setState({ shareLink: this.props.statusKasms.share_id });
      this.props.shareEnabled(true);
    }

    if (this.props.disconnect) {
      this.setState({ showNav: false });
    }

    if (this.props.show_tips === true) {
      renderNav = setTimeout(() => {
        this.hideNav();
      }, 3000);
    } else {
      this.setState({ showNav: false });
    }

    this.props.updateKeepalive(this.props.statusKasms.kasm_id);
    keepAlive = setInterval(() => {
      this.props
        .updateKeepalive(this.props.statusKasms.kasm_id)
        .then((data) => {
          if (data.response && data.response.usage_reached) {
            NotificationManager.error(
              "Session Usage Limit Reached",
              "Session Usage Limit",
              3000
            );
            this.handleLeave("/");
          }
        });
    }, 300000);

    if (this.props.statusKasms && this.props.statusKasms.client_settings) {
      this.setState({
        clipboardUp: this.props.statusKasms.client_settings
          .allow_kasm_clipboard_up,
        clipboardDown: this.props.statusKasms.client_settings
          .allow_kasm_clipboard_down,
        audio: this.props.statusKasms.client_settings.kasm_audio_default_on,
      });
    }

    // Add audio for when the domain already allows audio
    const { statusKasms } = this.props;

    if (
      statusKasms.client_settings &&
      statusKasms.client_settings.allow_kasm_audio &&
      statusKasms.port_map.audio
    ) {
      audio.initialize({
        canvasEl: document.querySelector("video-canvas"),
        url: `wss://${statusKasms.hostname}:${statusKasms.port_map.audio.port}/${statusKasms.port_map.audio.path}/`,
        isAllowed: statusKasms.client_settings.kasm_audio_default_on
      });

      // Auto-play on desktop or on user UI action on mobile
      if (statusKasms.client_settings.kasm_audio_default_on) {
        if (!IS_TOUCH_DEVICE) {
          audio.enable();
        } else {
          document.addEventListener("touchstart", () => audio.enable(), { once: true });
        }
      }
    }

    if (window.addEventListener) {
      window.addEventListener("message", this.receiveMessage, false);
      window.addEventListener("connection_state", this.receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("message", this.receiveMessage);
    }
    this.setState({ modal: false });

    window.addEventListener("blur", this.hideNavDelay);
  }

  hideNavDelay() {
    renderNav2 = setTimeout(() => {
      if (document.activeElement instanceof HTMLIFrameElement) {
        this.hideNav();
      }
    }, 10);
  }

  handleAudioProcess(event) {
    if (this.mic_ws.readyState === WebSocket.OPEN) {
      this.mic_ws.send(event.inputBuffer.getChannelData(0));
    }
  }

  handleSuccess(stream) {
    this.stream = stream;
    let AC = window.AudioContext || window.webkitAudioContext;
    this.audio_context = new AC();
    const source = this.audio_context.createMediaStreamSource(stream);

    const { statusKasms } = this.props;
    const microphone_url = `wss://${statusKasms.hostname}:${statusKasms.port_map.audio_input.port}/${statusKasms.port_map.audio_input.path}/?sample_rate=${source.context.destination.context.sampleRate}`;
    this.setState({ microphone_url });
    this.mic_ws = new WebSocket(microphone_url);

    const processor = this.audio_context.createScriptProcessor(2048, 1, 1);
    source.connect(processor);
    processor.connect(this.audio_context.destination);
    processor.onaudioprocess = this.handleAudioProcess;
  }

  connectMicrophone() {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(this.handleSuccess);
  }

  destroyMicrophone() {
    if (this.mic_ws) {
      this.mic_ws.close();
    }
    if (this.stream) {
      for (let track in this.stream.getAudioTracks()) {
        this.stream.getAudioTracks()[track].stop();
      }
    }
    if (this.audio_context) {
      this.audio_context.close();
    }
  }

  componentWillUnmount() {
    audio.disable();
    this.destroyMicrophone();
    clearInterval(keepAlive);
    clearTimeout(renderNav);
    clearTimeout(renderNav2);
    window.removeEventListener("message", this.receiveMessage, false);
    window.removeEventListener("connection_state", this.receiveMessage, false);
    window.removeEventListener("blur", this.hideNavDelay);
  }

  cancelLogout() {
    this.closeAllModals();
    this.toggleLogout();
    this.handleLeave("/");
  }

  showNav() {
    this.setState({ showNav: true });
    this.refreshNavState();
  }

  hideNav() {
    this.setState({ showNav: false });
  }

  toggleNav() {
    this.setState({ showNav: !this.state.showNav });
    this.refreshNavState();
  }

  refreshNavState() {
    // If the nav is open then refresh the contents if necessary
    if (this.state.modaldownload) {
      this.downloadsList();
    }

    // If the clipboard modal is open. Auto select the text. This should make the workflow of copy paste much faster
    if (this.state.modalclipboard) {
      // Chrome has a bug where the select doesnt apply immediately. Using set timeout gets around this.
      document.getElementById("clipboardtext").focus();
      setTimeout(function () {
        document.getElementById("clipboardtext").select();
      }, 50);
    }
  }

  toggleLogout() {
    this.setState({ modal: !this.state.modal });
  }

  toggleDownload() {
    if (this.state.modaldownload === false) this.downloadsList();
    this.setState({ modaldownload: !this.state.modaldownload });
  }

  toggleVideo() {
    this.setState({ modalvideo: !this.state.modalvideo });
  }

  toggleSharing() {
    this.setState({ modalsharing: !this.state.modalsharing });
  }

  toggleAdvanced() {
    this.setState({ modalAdvanced: !this.state.modalAdvanced });
  }

  toggleClipboard() {
    this.setState({ modalclipboard: !this.state.modalclipboard });
  }

  toggleUploads() {
    this.setState({
      modaluploads: !this.state.modaluploads,
      files: [],
      currentIndex: null,
      disableIndex: [],
      fileStatusArr: [],
      progress: 0,
    });
  }

  toggleDestroy() {
    this.setState({ modaldestroy: !this.state.modaldestroy });
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  handleClose(e) {
    this.handleLeave("/");
  }

  receiveMessage(event) {
    if (event.data && event.data.action == "clipboardrx") {
      if (this.state.clipboardDown) {
        this.setState({ clipboardText: event.data.value });
      }
    } else if (
      event.data &&
      event.data.action == "disconnectrx" &&
      !this.state.destroyClicked
    ) {
      this.props.handleDisconnect();
    } else if (event.data.action == "togglenav") this.toggleNav();
    else if (event.data.action == "idle_session_timeout") {
      window.disableAPIActiveState = 1;
      setTimeout(function () {
        window.disableAPIActiveState = 0;
      }, 5000);
      this.handleLeave("/");
    }
  }

  showMessage(i) {
    const { fileStatusArr } = this.state;
    let element = "";

    element = fileStatusArr.find(function (element) {
      return element.index === i;
    });

    if (element) {
      if (element && element["success-status"]) {
        return (
          <span className="text-success blk_inline mt-7">
            {" "}
            {element["success-status"]}{" "}
          </span>
        );
      } else if (element && element["failure-status"]) {
        return (
          <span className="text-danger blk_inline mt-7">
            {" "}
            {element["failure-status"]}{" "}
          </span>
        );
      }
    }
    return " ";
  }

  // FIXME KASM-365 This function doesnt actually trigger an update to the DOM to show the download lists. Rather, another
  //  bug that continuously refreshes the page causing the downloads to re-appear
  async downloadsList(path) {
    const { statusKasms } = this.props;
    let _path = path;
    if (_path === undefined) {
      _path = "";
    }
    var url = `https://${statusKasms.hostname}:${
      statusKasms.port_map.vnc.port
    }/${
      statusKasms.port_map.vnc.path
    }/Downloads/Downloads/${_path}?_=${new Date().getTime()}`;
    var real_url = `https://${statusKasms.hostname}:${statusKasms.port_map.vnc.port}/${statusKasms.port_map.vnc.path}/Downloads/Downloads/${_path}`;
    var downloads = [];

    await fetch(url, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        if (statusKasms.operational_status === "running") {
          var doc = document.implementation.createHTMLDocument("doc");
          doc.documentElement.innerHTML = data;
          downloads.length = 0;
          var h2 = doc.getElementsByTagName("h2");
          var root = h2[0].innerText
            .replace("/Downloads/Downloads/", "");

          var items = doc.getElementsByTagName("a");
          for (var i = 0; i < items.length; i++) {
            let is_dir = items[i].innerHTML.endsWith("/");
            // Don't show symlinks
            if (!items[i].innerHTML.endsWith("@")) {
              downloads.push({
                name: items[i].innerHTML,
                dlink: real_url + items[i].innerHTML,
                is_dir: is_dir,
                relative_path: root + items[i].innerHTML,
              });
            }
          }
        }
      });
    this.setState({ downloads: downloads });
  }

  handleClipboard(event) {
    // The websocket has a maxmium buffer size that can be safely sent.
    let maximumBufferSize = 10000;
    let clipboardText = event.target.value.slice(0, maximumBufferSize);
    this.setState({ clipboardText });

    if (this.state.clipboardUp) {
      document
        .getElementById("iframe-id")
        .contentWindow.postMessage(
          { action: "clipboardsnd", value: clipboardText },
          "*"
        );
    }
  }

  copyToClipboard(str) {
    const el = document.createElement("textarea");
    el.value = str;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    NotificationManager.success("Copied to Clipboard");
    document.body.removeChild(el);
  }

  openWindow(url) {
    window.open(
      url,
      "_blank",
      "resizable=yes,top=0,left=0,width=800,height=640"
    );
  }

  updateLogoutAll() {
    this.setState({ logoutAll: !this.state.logoutAll });
  }

  updateLogoutAll() {
    this.setState({ logoutAll: !this.state.logoutAll });
  }

  closeAllModals() {
    this.setState({
      isShowDownload: false,
      isShowClipboard: false,
      modaldownload: false,
      modalvideo: false,
      modaluploads: false,
      modalAdvanced: false,
      modalsharing: false,
    });
  }

  openModal(key) {
    this.closeAllModals();
    this.setState({
      [key]: true,
    });
  }

  render() {
    const { disableIndex, progress, downloads, shareLink } = this.state;
    const { statusKasms } = this.props;
    const userInfo = JSON.parse(window.localStorage.user_info);

    const defaultPreferLocalCursor = JSON.parse(
      window.localStorage.getItem("prefer_local_cursor") || "true"
    );

    const config = this.componentConfig;
    const djsConfig = this.djsConfig;

    const progressBars = this.state.files.map((file) => (
      <div key={file.name}>
        <strong>{file.name}</strong>{" "}
        <span className="float-right" style={{}}>
          {file.size}&nbsp;&nbsp;&nbsp;
          <button
            style={{
              background: "none",
              border: "none",
              margin: "0",
              padding: "0",
              cursor: "pointer",
              color: "red",
            }}
            onClick={() => this.removeFile(file)}
          >
            ✘
          </button>
        </span>
        <Progress
          animated
          className="pd=15"
          color={file.color}
          value={file.progress}
        />
        {file.error ? (
          <span style={{ color: "red" }}> {file.error} </span>
        ) : file.progress === 100 ? (
          "File Complete"
        ) : (
          ""
        )}
      </div>
    ));

    const eventHandlers = {
      init: (dz) => (this.dropzone = dz),
      addedfile: this.handleAddedFile,
      success: this.handleSuccessFile,
      uploadprogress: this.handleUploadprogress,
      error: this.handleError,
      sending: this.fileCanceled,
      queuecomplete: this.resetDropzone,
    };

    // Send an event to the parent document (kasm app) to toggle the control panel when ctl is double clicked

    var delta = 500;
    var lastKeypressTime = 0;
    if (this.props.toggle_control_panel === true) {
      document.addEventListener(
        "keyup",
        (event) => {
          const keyName = event.key;
          // CTRL and the various implementations of the mac command key
          if ([17, 224, 91, 93].indexOf(event.keyCode) > -1) {
            let thisKeypressTime = new Date();
            if (thisKeypressTime - lastKeypressTime <= delta) {
              this.toggleNav();
              thisKeypressTime = 0;
            }
            lastKeypressTime = thisKeypressTime;
          }
        },
        true
      );
    }

    const navOverride = this.props.hideControlPanel ? { display: "None" } : {};
    return (
      <div>
        <canvas id="video-canvas" />
        <i
          id="nav_toggle"
          className="fa fa-ellipsis-v toggle_icon"
          onClick={this.showNav}
          aria-hidden="true"
          style={navOverride}
        />
        <div className="countdown"></div>
        <div className="sidenavnew-outer">
          <div
            id="mySidenav"
            className={
              this.state.showNav && !this.props.hideControlPanel
                ? "sidenavnew show_nav"
                : "sidenavnew hide_nav"
            }
          >
            <div className="sidebar-icons-list">
              <button
                className="sidebar-icons "
                onClick={() => {
                  if (this.state.showNav) {
                    this.closeAllModals();
                  }
                  this.setState({
                    showNav: !this.state.showNav,
                  });
                }}
              >
                <img src={leftArrow} alt="leftArrow" />
                <div className="sidebar-icons-hover">
                  <p>Hide Toolbar</p>
                </div>
              </button>

              {statusKasms.client_settings.allow_kasm_audio == true && (
                <button
                  className={
                    "sidebar-icons square " +
                    (this.state.audio ? "soundEnabled" : "soundDisabled")
                  }
                  onClick={() => {
                    this.handleAudioChange(!this.state.audio);
                  }}
                >
                  <img
                    src={this.state.audio ? soundEnabled : soundDisabled}
                    alt="soundEnabled"
                  />
                  <div className="sidebar-icons-hover">
                    <p>
                      {this.state.audio ? "Sound Enabled" : "Sound Disabled"}
                    </p>
                  </div>
                </button>
              )}

              {!this.state.microphone &&
                statusKasms.client_settings.allow_kasm_microphone == true && (
                  <button
                    className="sidebar-icons square mute"
                    onClick={() => {
                      this.handleMicrophoneChange(!this.state.microphone);
                    }}
                  >
                    <img src={mute} alt="mute" />
                    <div className="sidebar-icons-hover">
                      <p>Microphone Disabled</p>
                    </div>
                  </button>
                )}

              {statusKasms.client_settings.allow_kasm_microphone == true &&
                this.state.microphone && (
                  <button
                    className="sidebar-icons square unmute"
                    onClick={() => {
                      this.handleMicrophoneChange(!this.state.microphone);
                    }}
                  >
                    <img src={unmute} alt="mute" />
                    <div className="sidebar-icons-hover">
                      <p>Microphone Enabled</p>
                    </div>
                  </button>
                )}
              {(statusKasms.client_settings.allow_kasm_clipboard_up ||
                statusKasms.client_settings.allow_kasm_clipboard_down ==
                  true) && (
                <div>
                  <button
                    className={`sidebar-icons ${
                      this.state.isShowClipboard ? "sidebar-icons-active" : ""
                    }`}
                    onClick={() => {
                      this.openModal("isShowClipboard");
                    }}
                  >
                    <img
                      src={clipboard}
                      width="20"
                      height="20"
                      alt="clipboard"
                    />
                    <div className="sidebar-icons-hover">
                      <p>Clipboard</p>
                    </div>
                  </button>
                  {this.state.isShowClipboard && (
                    <div className="popup showpopup">
                      <button
                        className="cross"
                        onClick={() => {
                          this.setState({
                            isShowClipboard: false,
                          });
                        }}
                      >
                        <img src={cross} alt="cross" />
                      </button>
                      <h5>Clipboard</h5>
                      <p>
                        The contents of the session's clipboard will be
                        available in the text area below. Enter text in the text
                        area below to make the content available to the session.
                      </p>
                      {statusKasms.client_settings.allow_kasm_clipboard_up ===
                      false ? (
                        <span style={{ color: "#f2a025", fontWeight: "bold" }}>
                          {" "}
                          Pasting data to the session is disabled.
                        </span>
                      ) : (
                        ""
                      )}
                      {statusKasms.client_settings.allow_kasm_clipboard_down ===
                      false ? (
                        <span style={{ color: "#f2a025", fontWeight: "bold" }}>
                          {" "}
                          Copying data from the session is disabled.
                        </span>
                      ) : (
                        ""
                      )}
                      <textarea
                        value={this.state.clipboardText}
                        onChange={this.handleClipboard}
                        className="clipboard-text form-control"
                        rows="6"
                        id="clipboardtext"
                      ></textarea>
                    </div>
                  )}
                </div>
              )}
              {statusKasms.client_settings.allow_kasm_downloads == true && (
                <div>
                  <button
                    className={`sidebar-icons ${
                      this.state.isShowDownload ? "sidebar-icons-active" : ""
                    }`}
                    onClick={() => {
                      this.openModal("isShowDownload");
                      this.toggleDownload();
                    }}
                  >
                    <img src={download} alt="download" />
                    <div className="sidebar-icons-hover">
                      <p>Download</p>
                    </div>
                  </button>
                  {this.state.isShowDownload && (
                    <div className="popup showpopup">
                      <button
                        className="cross"
                        onClick={() => {
                          this.setState({
                            isShowDownload: false,
                          });
                        }}
                      >
                        <img src={cross} alt="cross" />
                      </button>
                      <h5>Download Files</h5>
                      <p>
                        Items in the session's Downloads folder will be
                        available to download to your computer here.
                      </p>

                      {downloads.length > 0 &&
                        downloads.map((download) =>
                          download.is_dir ? (
                            <div className="downloader">
                              <ListGroupItem key={download.dlink}>
                                <a
                                  href="javascript:;"
                                  onClick={() =>
                                    this.downloadsList(download.relative_path)
                                  }
                                >
                                  <img src={file} alt="file" />
                                  {download.name}
                                </a>
                              </ListGroupItem>
                            </div>
                          ) : (
                            <div className="downloader">
                              <ListGroupItem key={download.dlink}>
                                <a href={download.dlink} download>
                                  <img src={file} alt="file" />
                                  {download.name}
                                </a>
                              </ListGroupItem>
                            </div>
                          )
                        )}
                    </div>
                  )}
                </div>
              )}
              {statusKasms.client_settings.allow_kasm_uploads == true && (
                <div>
                  <button
                    className={`sidebar-icons ${
                      this.state.modaluploads ? "sidebar-icons-active" : ""
                    }`}
                    onClick={() => {
                      this.openModal("modaluploads");
                    }}
                  >
                    <img src={upload} alt="upload" />
                    <div className="sidebar-icons-hover">
                      <p>Upload</p>
                    </div>
                  </button>

                  {this.state.modaluploads && (
                    <div className="popup showpopup">
                      <button
                        className="cross"
                        onClick={() => {
                          this.setState({
                            modaluploads: false,
                          });
                        }}
                      >
                        <img src={cross} alt="cross" />
                      </button>
                      <h5>Upload Files</h5>
                      <DropzoneComponent
                        className="upload-file"
                        config={config}
                        djsConfig={djsConfig}
                        eventHandlers={eventHandlers}
                      />
                      {progressBars}
                      <div className="btn-clear-all">
                        {this.state.files.length > 0 ? (
                          <button
                            className="mt-1 btn btn-primary"
                            onClick={() => this.clearFiles()}
                          >
                            Clear all
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div>
                <button
                  className={`sidebar-icons ${
                    this.state.modalvideo ? "sidebar-icons-active" : ""
                  }`}
                  onClick={() => {
                    this.openModal("modalvideo");
                  }}
                >
                  <img src={streaming} alt="streaming" />
                  <div className="sidebar-icons-hover">
                    <p>Streaming Quality</p>
                  </div>
                </button>

                {this.state.modalvideo && (
                  <div className="popup showpopup">
                    <button
                      className="cross"
                      onClick={() => {
                        this.setState({
                          modalvideo: false,
                        });
                      }}
                    >
                      <img src={cross} alt="cross" />
                    </button>
                    <h5>Streaming Quality</h5>
                    <p>
                      Lower streaming quality settings reduce bandwidth utilization and improve responsiveness.{" "}
                    </p>
                    <div className="radio-outer-box">
                      <div className="radio-outer">
                        <input
                          className=""
                          type="radio"
                          id="test1"
                          value="Static"
                          name="radio-group"
                          checked={this.props.videoQuality === 0}
                          onChange={() => {
                            const setQuality = this.props.setVideoQuality.bind(
                              this
                            );
                            setQuality(0);
                          }}
                        />
                        <label for="test1">Static</label>
                      </div>
                      <div className="radio-outer">
                        <input
                          className=""
                          type="radio"
                          id="test2"
                          value="Low"
                          name="radio-group"
                          checked={this.props.videoQuality === 1}
                          onChange={() => {
                            const setQuality = this.props.setVideoQuality.bind(
                              this
                            );
                            setQuality(1);
                          }}
                        />
                        <label for="test2">Low</label>
                      </div>
                      <div className="radio-outer">
                        <input
                          className=""
                          type="radio"
                          id="test3"
                          value="Medium"
                          name="radio-group"
                          checked={this.props.videoQuality === 2}
                          onChange={() => {
                            const setQuality = this.props.setVideoQuality.bind(
                              this
                            );
                            setQuality(2);
                          }}
                        />
                        <label for="test3">Medium</label>
                      </div>
                      <div className="radio-outer">
                        <input
                          className=""
                          type="radio"
                          id="test4"
                          value="high"
                          name="radio-group"
                          checked={this.props.videoQuality === 3}
                          onChange={() => {
                            const setQuality = this.props.setVideoQuality.bind(
                              this
                            );
                            setQuality(3);
                          }}
                        />
                        <label for="test4">High</label>
                      </div>
                      <div className="radio-outer">
                        <input
                            className=""
                            type="radio"
                            id="test5"
                            value="extreme"
                            name="radio-group"
                            checked={this.props.videoQuality === 4}
                            onChange={() => {
                              const setQuality = this.props.setVideoQuality.bind(
                                  this
                              );
                              setQuality(4);
                            }}
                        />
                        <label htmlFor="test5">Extreme</label>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {statusKasms.client_settings.allow_kasm_sharing == true && (
                <div>
                  <button
                    className={`sidebar-icons ${
                      this.state.modalsharing ? "sidebar-icons-active" : ""
                    }`}
                    onClick={() => {
                      this.openModal("modalsharing");
                    }}
                  >
                    <img src={share} alt="share" />
                    <div className="sidebar-icons-hover">
                      <p>Share Instance</p>
                    </div>
                  </button>
                  {this.state.modalsharing && (
                    <div className="popup showpopup">
                      <button
                        className="cross"
                        onClick={() => {
                          this.setState({
                            modalsharing: false,
                          });
                        }}
                      >
                        <img src={cross} alt="cross" />
                      </button>
                      <h5>Share Session</h5>
                      <p>
                        Share view-only access to this session with other users.
                      </p>
                      {shareLink ? (
                        <div>
                          <div className="d-flex">
                            <div className="share-link d-flex">
                              <button
                                className="btn btn-link share-btn"
                                onClick={() => {
                                  this.openWindow(
                                    "https://" +
                                      window.location.host +
                                      window.location.pathname +
                                      "#/join/" +
                                      shareLink
                                  );
                                }}
                              >
                                {"https://" +
                                  window.location.host +
                                  window.location.pathname +
                                  "#/join/" +
                                  shareLink}
                              </button>
                              <button
                                className="btn btn-default btn-sm copy-share-button"
                                onClick={() => {
                                  this.copyToClipboard(
                                    "https://" +
                                      window.location.host +
                                      window.location.pathname +
                                      "#/join/" +
                                      shareLink
                                  );
                                }}
                              >
                                <i className="fa fa-copy" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
                          <div id="share_tips">
                            <h4>Sharing Tips!</h4>
                            <p>
                              Any User with this link can view this Session and
                              participate in chat.
                            </p>
                            <p>
                              Changes to the video setting effect all viewers.
                              When sharing is enabled, the resolution is fixed
                              by default to ensure a consistent experience for
                              all viewers.
                            </p>
                          </div>
                          <button
                            className="share-kasm-btn"
                            onClick={this.handleDestroyShareLink}
                          >
                            Stop Sharing
                          </button>
                        </div>
                      ) : (
                        <button
                          className="share-kasm-btn"
                          onClick={this.handleCreateShareLink}
                        >
                          <i className="fa fa-share" />
                          Share Session
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div>
                <button
                  className={`sidebar-icons ${
                    this.state.modalAdvanced ? "sidebar-icons-active" : ""
                  }`}
                  onClick={() => {
                    this.openModal("modalAdvanced");
                  }}
                >
                  <img src={configure} alt="configure" />
                  <div className="sidebar-icons-hover">
                    <p>Configure</p>
                  </div>
                </button>
                {this.state.modalAdvanced && (
                  <div className="popup showpopup">
                    <button
                      className="cross"
                      onClick={() => {
                        this.setState({
                          modalAdvanced: false,
                        });
                      }}
                    >
                      <img src={cross} alt="cross" />
                    </button>
                    <h5>Advanced Settings</h5>
                    <div className="check-outer-box">
                      <label className="check-outer">
                        Prefer Local Cursor
                        <input
                          type="checkbox"
                          defaultChecked={defaultPreferLocalCursor}
                          onChange={this.handlePreferLocalCursorChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <h6 style={{marginTop: "40px"}}>Show Keyboard Controls</h6>
                    <div className="radio-outer-box">
                      {!IS_WINDOWS && <div className="radio-outer">
                        <input
                          type="radio"
                          value="auto"
                          id="keyboard-auto"
                          name="radio-group"
                          checked={this.state.keyboardControlsMode === "auto"}
                          onChange={() => this.setKeyboardControlsMode("auto")}
                        />
                        <label for="keyboard-auto">Auto</label>
                      </div>}
                      <div className="radio-outer">
                        <input
                          type="radio"
                          value="on"
                          id="keyboard-on"
                          name="radio-group"
                          checked={this.state.keyboardControlsMode === "on"}
                          onChange={() => this.setKeyboardControlsMode("on")}
                        />
                        <label for="keyboard-on">On</label>
                      </div>
                      <div className="radio-outer">
                        <input
                          type="radio"
                          value="off"
                          id="keyboard-off"
                          name="radio-group"
                          checked={this.state.keyboardControlsMode === "off"}
                          onChange={() => this.setKeyboardControlsMode("off")}
                        />
                        <label for="keyboard-off">Off</label>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <button
                className="sidebar-icons"
                onClick={() => this.handleLeave("/userdashboard")}
              >
                <img src={apps} alt="apps" />
                <div className="sidebar-icons-hover">
                  <p>Return to Workspaces</p>
                </div>
              </button>
              <button
                className="sidebar-icons"
                onClick={() => this.showLogout()}
              >
                <img src={logout} alt="logout" />
                <div className="sidebar-icons-hover">
                  <p>Log Out</p>
                </div>
              </button>
              <button
                className="sidebar-icons"
                onClick={() => this.showDestroy()}
              >
                <img
                  src={redTrashCanIcon}
                  width="20"
                  height="20"
                  alt="redTrashCanIcon"
                />
                <div className="sidebar-icons-hover">
                  <p>Delete Session</p>
                </div>
              </button>
            </div>
          </div>
        </div>
        <Modal
          zIndex={999999}
          isOpen={this.state.modal}
          toggle={this.toggleLogout}
          className="launch-modal"
        >
          <ModalBody style={{maxHeight: "245px"}}>
            <div className="modal-inner">
              <div className="opera-box">
                <div className="opera-box-img">
                  {this.state.deleteKasmImage != "" ? (
                    <img
                      src={this.props.statusKasms.image.image_src}
                    />
                  ) : (
                    <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                  )}
                </div>
                <div className="opera-box-detail">
                  <div className="modal-item">
                    <h4>{this.props.statusKasms.image.friendly_name}</h4>
                    <button className="close-icon" onClick={this.toggleLogout}>
                      <img src={cross} alt="close" />
                    </button>
                  </div>
                  <p className="opera-Productivity">
                    <span>Are you sure you want to logout?</span>
                  </p>
                </div>
              </div>
              <p className="opera-Productivity">
                <span><input type="checkbox" value={this.state.logoutAll} onChange={this.updateLogoutAll}/> &nbsp; &nbsp;Sign out of all devices.</span>
              </p>
              <div>
                <Button 
                  onClick={this.confirmLogout}
                  color="danger"
                  style={{ width: "100%", padding: "20px"}}
                >
                  Logout
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          zIndex={999999}
          isOpen={this.state.modaldestroy}
          toggle={this.toggleDestroy}
        >
          <ModalBody style={{maxHeight: "245px"}}>
            <div className="modal-inner">
              <div className="opera-box">
                <div className="opera-box-img">
                  {this.state.deleteKasmImage != "" ? (
                    <img
                      src={this.props.statusKasms.image.image_src}
                    />
                  ) : (
                    <i className="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left" />
                  )}
                </div>
                <div className="opera-box-detail">
                  <div className="modal-item">
                    <h4>{this.props.statusKasms.image.friendly_name}</h4>
                    <button className="close-icon" onClick={this.toggleDestroy}>
                      <img src={cross} alt="close" />
                    </button>
                  </div>
                  <p className="opera-Productivity">
                    <span>Are you sure you want to delete this session?</span>
                  </p>
                </div>
              </div>
              <div>
                <Button 
                  onClick={this.destroyKasmsFun}
                  color="danger"
                  style={{ width: "100%", padding: "20px"}}
                >
                  Delete
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

ControlPanel.propTypes = {
  logout: Proptypes.func.isRequired,
  toggleLoader: Proptypes.func.isRequired,
  destroyKasms: Proptypes.func.isRequired,
  statusKasms: Proptypes.object,
  history: Proptypes.object,
  updateKeepalive: Proptypes.func.isRequired,
  kasmId: Proptypes.func,
  videoQuality: Proptypes.number,
  setVideoQuality: Proptypes.func,
  setVideoQualityStyle: Proptypes.func,
  handleDisconnect: Proptypes.func,
  shareEnabled: Proptypes.func.isRequired,
  hideControlPanel: Proptypes.bool,
  disableFixedRes: Proptypes.bool,
};

ControlPanel = withRouter(ControlPanel); // eslint-disable-line

export default connect(
  (state) => ({
    share_id: state.dashboard.share_id || null,
    destroyShareLoading: state.dashboard.destroyShareLoading || null,
    destroyShareError: state.dashboard.destroyShareError || null,
    createShareLoading: state.dashboard.createShareLoading || null,
    createShareError: state.dashboard.createShareError || null,
  }),
  (dispatch) => ({
    createKasmShareId: (data) => dispatch(createKasmShareId(data)),
    destroyKasmShareId: (data) => dispatch(destroyKasmShareId(data)),
  })
)(ControlPanel);



// WEBPACK FOOTER //
// ./src/components/ControlPanel/ControlPanel.js